import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Keyboard } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { images } from "../../Assets/images";

const productImages = [
    images.product1,
    images.product2
];

const ProductDetails = () => {
    const [currentImage, setCurrentImage] = useState(productImages[0]);
    const [fullscreenImage, setFullscreenImage] = useState(null);
    const swiperRef = useRef(null);

    //   const currentImageIndex = productImages.indexOf(currentImage);

    const product = {
        name: "4Life Transfer Factor RioVida",
        price: 45.0,
        rating: 4.5,
        reviews: 3,
        description:
            "Superfruit immune and antioxidant support shot powered by 4Life Transfer Factor®. This is the only antioxidant-rich immune shot in the world powered by 4Life Transfer Factor®: bioactive immune peptides clinically proven to activate the immune system within two hours.",
        supports: [
            "Immune System",
            "Antioxidant",
            "Healthy Aging",
            "Overall Wellness",
        ],
        features: [
            "Contains 4Life Transfer Factor, clinically proven to activate immune system within 2 hours",
            "Includes 600 mg of 4Life Transfer Factor",
            "Antioxidant-rich with açaí, pomegranate, blueberry, elderberry, maqui berry, and aronia berry",
            "Contains Vitamin C, amino acids, fatty acids, and polyphenols",
            "For ages 2 and up",
        ],
        specs: {
            servingSize: "1 fl oz (30 ml)",
            servingsPerContainer: 18,
            supplementType: "Drink",
            containerAmount: "18 fl oz",
        },
    };

    return (
        <div className="content-part">
            <div className="product-details-container">
                <div className="row product-details-row">
                    <div className="col-lg-6">
                        <div className="mb-4">
                            <Swiper
                                ref={swiperRef}
                                modules={[Pagination, Keyboard]}
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                keyboard={{ enabled: true }}
                                onSlideChange={(swiper) =>
                                    setCurrentImage(productImages[swiper.activeIndex])
                                }
                                className="product-swiper"
                            >
                                {productImages.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="main-product-image">
                                            <img
                                                src={img}
                                                alt="product"
                                                className="product-image-img"
                                                onClick={() => setFullscreenImage(img)}
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                        <div className="d-flex gap-2 flex-wrap">
                            {productImages.map((img, index) => (
                                <div
                                    key={index}
                                    className={`border rounded p-2 thumbnail-gallery ${currentImage === img ? "active" : ""}`}
                                    onClick={() => {
                                        setCurrentImage(img);
                                        if (swiperRef.current) {
                                            swiperRef.current.swiper.slideTo(index);
                                        }
                                    }}
                                >
                                    <img src={img} alt={`thumbnail-${index}`} />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <span className="text-warning rating-text">
                                ★★★★☆ {product.rating}
                            </span>
                            <span className="text-muted ms-2">
                                ({product.reviews} Reviews)
                            </span>
                        </div>

                        <h3 className="mb-3 product-title">{product.name}</h3>

                        <h4 className="text-success mb-3 product-price">
                            ${product.price.toFixed(2)}
                        </h4>

                        <h5 className="fw-bold">Product Details</h5>
                        <p className="text-muted mb-4 product-description">
                            {product.description}
                        </p>

                        <div>
                            <h5 className="fw-bold">Product Supports</h5>
                            <div className="d-flex flex-wrap gap-2">
                                {product.supports.map((support, index) => (
                                    <div key={index} href="#" className="support-badge">
                                        {support}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row my-3">
                    <div className="col-12">
                        <h5 className="fw-bold mb-3 section-heading">Main Features</h5>
                        <ul className="list-unstyled">
                            {product.features.map((feature, index) => (
                                <li key={index} className="mb-2">
                                    <i className="fas fa-check text-success me-2"></i>
                                    <span className="feature-item-text">{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="row my-3">
                    <div className="col-12">
                        <h5 className="fw-bold mb-3 section-heading">Directions for Use</h5>
                        <p className="mb-1">
                            Drink one (1) or more ounces daily. Shake well before each
                            serving.
                        </p>
                        <p className="mb-0">Refrigerate after opening.</p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <h5 className="fw-bold mb-3 section-heading">Patents</h5>
                        <p className="mb-0">
                            Patents protect our unique processes and formulas. With every new
                            patent, our products become more unique in the marketplace and our
                            formulas and processes become more secure.
                        </p>
                    </div>
                </div>

                <div className="row my-3">
                    <div className="col-12">
                        <h5 className="fw-bold mb-3 section-heading">
                            Product Specifications
                        </h5>
                        <table className="table specs-table">
                            <tbody>
                                <tr className="specs-table-row">
                                    <td className="fw-bold text-muted specs-table-cell label-cell">
                                        Serving Size
                                    </td>
                                    <td className="specs-table-cell">
                                        {product.specs.servingSize}
                                    </td>
                                </tr>
                                <tr className="specs-table-row">
                                    <td className="fw-bold text-muted specs-table-cell label-cell">
                                        Servings Per Container
                                    </td>
                                    <td className="specs-table-cell">
                                        {product.specs.servingsPerContainer}
                                    </td>
                                </tr>
                                <tr className="specs-table-row">
                                    <td className="fw-bold text-muted specs-table-cell label-cell">
                                        Supplement Type
                                    </td>
                                    <td className="specs-table-cell">
                                        {product.specs.supplementType}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="fw-bold text-muted specs-table-cell label-cell">
                                        Container Amount
                                    </td>
                                    <td className="specs-table-cell">
                                        {product.specs.containerAmount}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <h5 className="fw-bold mb-3 review-heading">
                            Customer Reviews ({product.reviews})
                        </h5>

                        <div className="review-item">
                            <div className="d-flex align-items-center mb-2">
                                <span className="text-warning me-2 review-rating">★★★★★</span>
                                <strong className="review-author">Maria M</strong>
                                <span className="text-success ms-2 small review-verified">
                                    Verified Customer
                                </span>
                            </div>
                            <p className="review-text">
                                "Este juguito esta riquisimo y va dirigido al sistema
                                inmunologico, es un antioxidante riquisimo"
                            </p>
                            <p className="mb-0 text-muted fs-12px text-end mt-1">
                                Bellmawr, US 1/29/2026
                            </p>
                        </div>

                        <div className="review-item">
                            <div className="d-flex align-items-center mb-2">
                                <span className="text-warning me-2 review-rating">★★★★★</span>
                                <strong className="review-author">Marcelino C</strong>
                                <span className="text-success ms-2 small review-verified">
                                    Verified Customer
                                </span>
                            </div>
                            <p className="review-text">
                                "The perfect antioxidant for your body"
                            </p>
                            <p className="mb-0 text-muted fs-12px text-end mt-1">
                                El Paso, US 2/12/2026
                            </p>
                        </div>

                        <div className="review-item">
                            <div className="d-flex align-items-center mb-2">
                                <span className="text-warning me-2 review-rating">★★★★★</span>
                                <strong className="review-author">Daysi G</strong>
                                <span className="text-success ms-2 small review-verified">
                                    Verified Customer
                                </span>
                            </div>
                            <p className="review-text">"Life changing"</p>
                            <p className="mb-0 text-muted fs-12px text-end mt-1">
                                Seattle, US 1/4/2026
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {fullscreenImage && (
                <div
                    className="fullscreen-preview"
                    onClick={() => setFullscreenImage(null)}
                    onKeyDown={(e) => {
                        if (e.key === "Escape") setFullscreenImage(null);
                    }}
                    tabIndex="0"
                    style={{ outline: "none" }}
                >
                    <img
                        src={fullscreenImage}
                        alt="fullscreen"
                        className="fullscreen-preview-img"
                    />

                    {/* Close Button */}
                    <button
                        className="fullscreen-close-btn"
                        onClick={() => setFullscreenImage(null)}
                        title="Close"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            )}
        </div>
    );
};

export default ProductDetails;
